import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function TermsAndConditions() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <div className="wrapper">
        <button className="back-btn" onClick={() => navigate('/')}>← Back to Home</button>

        <h1 className="legal-title">Terms and Conditions</h1>
        <p className="legal-effective">Effective Date: January 1, 2026</p>

        <div className="legal-content">

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing or using the services provided by Deutsche Business Solutions, Inc.
              ("DBS," "we," "us," or "our"), you agree to be bound by these Terms and Conditions.
              If you do not agree to all the terms stated herein, please refrain from using our
              services.
            </p>
          </section>

          <section>
            <h2>2. Description of Services</h2>
            <p>
              Deutsche Business Solutions, Inc. provides virtual assistance, back office support,
              and technical support services to businesses and individuals. Our services include,
              but are not limited to:
            </p>
            <ul>
              <li>Virtual Assistant services (scheduling, correspondence, data entry, research)</li>
              <li>Back Office Support (document processing, data management, administrative tasks)</li>
              <li>Technical Support (IT assistance, troubleshooting, system monitoring)</li>
            </ul>
          </section>

          <section>
            <h2>3. Client Responsibilities</h2>
            <p>
              As a client of DBS, you agree to:
            </p>
            <ul>
              <li>Provide accurate and complete information required to perform the services.</li>
              <li>Communicate task requirements clearly and in a timely manner.</li>
              <li>Ensure all materials and information shared with DBS are legally obtained and do not infringe on third-party rights.</li>
              <li>Maintain confidentiality of your account credentials and notify us immediately of any unauthorized use.</li>
            </ul>
          </section>

          <section>
            <h2>4. Payment Terms</h2>
            <p>
              Payment for services shall be made in accordance with the agreed service plan or
              contract. DBS reserves the right to suspend services in the event of non-payment.
              All fees are non-refundable unless otherwise specified in a separate written agreement.
            </p>
          </section>

          <section>
            <h2>5. Confidentiality</h2>
            <p>
              DBS understands the sensitive nature of business operations. All information shared
              by clients is treated with the utmost confidentiality. Our team members are bound by
              non-disclosure agreements and are prohibited from sharing, selling, or misusing any
              client data.
            </p>
          </section>

          <section>
            <h2>6. Intellectual Property</h2>
            <p>
              All deliverables produced by DBS on behalf of a client become the intellectual
              property of that client upon full payment. DBS retains ownership of its proprietary
              tools, templates, and methodologies unless otherwise agreed upon in writing.
            </p>
          </section>

          <section>
            <h2>7. Limitation of Liability</h2>
            <p>
              Deutsche Business Solutions, Inc. shall not be held liable for any indirect,
              incidental, or consequential damages arising from the use or inability to use our
              services. Our total liability shall not exceed the total fees paid by the client in
              the three (3) months preceding the claim.
            </p>
          </section>

          <section>
            <h2>8. Termination</h2>
            <p>
              Either party may terminate the service agreement with written notice as specified in
              the service contract. DBS reserves the right to terminate services immediately if a
              client violates these Terms and Conditions or engages in unlawful activities.
            </p>
          </section>

          <section>
            <h2>9. Governing Law</h2>
            <p>
              These Terms and Conditions shall be governed by and construed in accordance with the
              laws of the Republic of the Philippines. Any disputes arising from the use of our
              services shall be subject to the exclusive jurisdiction of the courts located in
              the Philippines.
            </p>
          </section>

          <section>
            <h2>10. Changes to Terms</h2>
            <p>
              DBS reserves the right to update these Terms and Conditions at any time. Clients
              will be notified of significant changes via email or through our website. Continued
              use of our services after any changes constitutes acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h2>11. Contact Us</h2>
            <p>
              If you have any questions regarding these Terms and Conditions, please contact us:
            </p>
            <p>
              <strong>Deutsche Business Solutions, Inc.</strong><br />
              Email: info@deutschesolutions.com<br />
              Website: www.deutschesolutions.com
            </p>
          </section>

        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;